module.exports = __webpack_public_path__ + "static/media/TTA_Financial_Protection_150x82.cfcb9ea6.png";